"use client";
import { useMantineTheme } from "@mantine/core";
const useTheme = () => useMantineTheme();
export {
  useTheme
};
